import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		userInfo: null, // 用户信息
		location: null, // 当前定位信息
		city: '北京', //当前城市
    setSupplyData:{},//供应商数据中转
    isBack:false,//供应商表单后退判断依据
    isFirm:false//当前是否进行了企业认证
	},
	mutations: {
		// 退出登录
		logout(state) {
			state.userInfo = null;
			localStorage.removeItem('USER_INFO');
			localStorage.removeItem('user_token');
		},
		initApp(state) {
		  const _userInfo = JSON.parse(localStorage.getItem('USER_INFO'))
		  console.log(_userInfo);
		  if (_userInfo) {
		    state.userInfo = _userInfo;
		    // global.userInfo = _userInfo;
		    // global.token = _userInfo.token;
		  }
		},
		// 更新用户信息
		updateUserInfo(state, data) {
			if (state.userInfo) {
				state.userInfo = {
					...state.userInfo,
					...data,
				};
			} else {
				state.userInfo = data;
			}
			localStorage.setItem('USER_INFO', JSON.stringify(state.userInfo));
		},
		updatecity(state, data) {
			console.log('updatecity');
			if (state.city) {
				state.city = data
			} else {
				state.city = data;
			}
			console.log('updatecity', state.city);
		},
		// 更新当前定位信息
		updateLocation(state, data) {
			if (data.lat && data.lng) {
				state.location = data;
			}
		},
    // 改变state数据用于中转供应商
    setSupplyAdd(state,payload){
        state.setSupplyData = payload;
    },
    // 供应商表单后退判断改变
    isBackFun(state,payload){
        state.isBack = payload;
    },
    // 改变企业认证依据
    isFirmFun(state,payload){
        state.isFirm = payload;
    }
	},
	getters: {
		isLogin(state) {
			console.log(state.userInfo);
			if (state.userInfo == null) {
				return false;
			} else {
				return true;
			}
		},

		// 用户信息
		userInfo(state) {
			if (state.userInfo) {
				return state.userInfo;
			} else {
				return null;
			}
		},
		city(state) {
			if (state.city) {
				return state.city;
			} else {
				return null;
			}
		},
		location(state) {
			if (state.location) {
				return state.location;
			} else {
				return null;
			}
		}
	},
	actions: {},
	modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js